import { render, staticRenderFns } from "./CreatePageDialog.vue?vue&type=template&id=28a9c19d&"
import script from "./CreatePageDialog.vue?vue&type=script&lang=js&"
export * from "./CreatePageDialog.vue?vue&type=script&lang=js&"
import style0 from "./CreatePageDialog.vue?vue&type=style&index=0&id=28a9c19d&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports